angular
    .module("index.service")
    .service("httpService", ['$http', '$q', '$filter', '$rootScope', '$timeout', 'popupService', 'commonConst',
        function ($http, $q, $filter, $rootScope, $timeout, popupService, commonConst) {
            return {
                httpRequest: httpRequest,
                downloadFile: downloadFile,
                fileHttpRequest: fileHttpRequest,
                getAuthorizationToken: getAuthorizationToken
            };

            function fileHttpRequest(data, options) {
                //APITarget is the API location to call in the backend apis
                //Values is the data we submit
                options = options || {};
                // var fd = new FormData();
                // angular.forEach(Files, function (item) {
                //     fd.append('files', item._file, item.name);
                // });
                // fd.append("model", data);
                $rootScope.loaderOn = true;

                var authorizeToken = getAuthorizationToken(options);
                var request = $http({
                    url: "single_upload_handler.php",
                    method: "POST",
                    headers: {
                        'Content-Type': undefined,
                        'Authorization': authorizeToken
                    },
                    data: data
                });
                return (request.then(handleSuccess, handleError).finally(function (params) {
                    $rootScope.loaderOn = false;
                }));
            }

            function httpRequest(APITarget, Values, method, options) {
                if (!$rootScope.noOfReq) {
                    $rootScope.noOfReq = 0;
                }

                if (commonConst.IGNORE_APIs.indexOf(APITarget) == -1) {
                    $rootScope.noOfReq++;
                }
                if (Values) {
                    Values = JSON.parse(Values);
                    if (typeof Values == 'string') {
                        Values = Values.trim();
                    }

                    if (typeof Values == 'object') {
                        for (var Value in Values) {
                            if (typeof Values[Value] == 'string') {
                                Values[Value] = Values[Value].trim();
                            }
                        }
                    }
                    Values = JSON.stringify(Values);
                }
                //APITarget is the API location to call in the backend apis
                //Values is the data we submit
                options = options || {};

                var beforeSend = options.beforeSend;
                var afterSend = options.afterSend;
                var responseType = options.responseType;
                var authorizeToken = getAuthorizationToken(options);
                if (angular.isFunction(beforeSend))
                    beforeSend();
                else if (commonConst.IGNORE_APIs.indexOf(APITarget) == -1)
                    $rootScope.loaderOn = true;
                //console.log(APITarget+" - "+Values);
                var request = $http({
                    url: "remote_server_call.php",
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSS-Protection': '1; mode=block',
                        'X-Content-Type-Options': 'nosniff',
                        'X-Frame-Options': 'SAMEORIGIN',
                        'Content-Security-Policy': 'default-src "self"',
                        'Strict-Transport-Security': 'max-age=16070400; includeSubDomains',
                        'Authorization': authorizeToken
                    },
                    responseType: angular.isDefined(responseType) ? responseType : '',
                    data: {
                        URL: APITarget,
                        Values: Values,
                        method: angular.isDefined(method) ? method : 'GET'
                    }
                });

                return (request.then(handleSuccess, handleError).finally(function (params) {
                    if (commonConst.IGNORE_APIs.indexOf(APITarget) == -1) {
                        $rootScope.noOfReq--;
                    }
                    if (angular.isFunction(afterSend))
                        afterSend();
                    else {
                        if ($rootScope.noOfReq <= 0) {
                            $rootScope.loaderOn = false;
                            $rootScope.noOfReq = 0;
                        }
                    }

                }));
            }

            function handleError(response) {
                //console.log("error "+ $filter('decstr64')(response));
                var api_response = "";
                var genericMessage = "An unknown error occurred.";
                var data = {}
                if (angular.isObject(response)) {
                    data = getJsonResponse(response)

                    if (isBadRequest(response)) {
                        return $q.reject(data.api_response);
                    } else if (isUnAuthorizedRequest(response)) {
                        handleSessionExpired();
                        return;
                    }
                    api_response = data.api_response || response.data.api_response;
                }

                //var api_response = angular.isObject(response) === true ?( response.data.api_response) : "";
                if (!angular.isDefined(api_response)) {
                    popupService.showError("An error occurred. That may request reach timeout limit");
                    return ($q.reject());
                } else if ($filter('empty')(api_response) === true) {
                    popupService.showError(genericMessage);
                    return ($q.reject());
                } else {
                    var message = data.message || response.data.message || angular.fromJson(api_response).Message || genericMessage;
                    popupService.showText(message);
                    return ($q.reject());
                }
            }
            // I transform the successful response, unwrapping the application data
            // from the API response payload.
            function handleSuccess(response) {
                if (isFileResultResponse(response)) {
                    return {
                        hasFile: true,
                        File: response.data
                    };
                }
                var data = getJsonResponse(response);

                var api_response = data.api_response || response.data.api_response;
                //console.log("handleSuccess decoded " + (api_response));
                var errorCheck = serverErrorCheck(api_response);

                if (errorCheck !== true) {
                    return (api_response);
                } else {
                    var sessionTimedOut = angular.fromJson(api_response);
                    if (sessionTimedOut.ExceptionMessage === "Invalid identifier/session key" || sessionTimedOut.ExceptionMessage === "Session timed out") {
                        handleSessionExpired();
                        //return ("logout");
                    } else {
                        return false;
                    }
                }
            }

            function handleSessionExpired() {
                popupService.showError("Your Login Session Has Expired. Please Login Again", null, function () {
                    $rootScope.userLogout();
                });
            }

            function serverErrorCheck(data) {
                var decstr64 = data || "{}";
                //console.log("server response: " + decstr64);

                var decodeData = decstr64 ? (JSON.parse(decstr64) || "") : "";
                if (decodeData === "" && decodeData === null && decodeData === "null") {
                    popupService.showError("An Error Occurred. Please Try Again Later.");
                    return true;
                }
                if (decodeData.ExceptionMessage === "Invalid format") {
                    return false;
                } else {
                    if (!decodeData.Message) {
                        return false;
                    }

                    if (decodeData.ExceptionMessage === "Invalid identifier/session key" || decodeData.ExceptionMessage === "Session timed out") {
                        //popupService.showError("Your Login Session Has Expired Please Login Again");
                    } else if (decodeData.Message === "Please Insert Valid Login Credential") {
                        popupService.showError(decodeData.Message);
                    } else {
                        popupService.showError(decodeData.Message, null, function () {
                            $rootScope.passwordResetPopupOn = false;
                            popupService.hide();
                        });
                    }
                    return true;
                }
            } //end serverErrorCheck          
            function downloadFile(filePath, APITarget) {
                //APITarget is the API location to call in the backend apis
                //Values is the data we submit
                $rootScope.loaderOn = true;
                //console.log(APITarget+" - "+Values);
                var request = $http({
                    url: APITarget,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: "POST",
                    data: {
                        filePath: filePath
                    }
                });

                request.then(function (result) {
                    //console.log(result);
                })
            }

            function isFileResultResponse(response) {
                var fileContentTypes = [
                    "application/pdf",
                    "application/vnd.ms-excel",
                    "text/csv",
                    "application/octet-stream",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ]; //Add more file type here
                var headers = response.headers();
                var contentType = headers['content-type'];
                return fileContentTypes.indexOf(contentType) >= 0;
            }

            function getJsonResponse(response) {
                var responseType = response.config.responseType || '';
                if (responseType === 'arraybuffer' && !isFileResultResponse(response)) {
                    var uintArray = new Uint8Array(response.data)
                    var responseString = String.fromCharCode.apply(null, uintArray);
                    return angular.fromJson(responseString) || {};
                }
                return response.data;
            }

            function isBadRequest(response) {
                return response.status === 400 && angular.isDefined(response.data) && angular.isDefined(response.data.api_response);
            }

            function isUnAuthorizedRequest(response) {
                return response.status === 401;
            }

            function getAuthorizationToken(options) {
                options = options || {};
                var identifier = options.identifier || ($rootScope.user ? $rootScope.user.Identifier : '');
                var sessionKey = options.sessionKey || $filter('decstr64')($rootScope.user ? $rootScope.user.SessionKey : '') || '';
                if (identifier === '' && sessionKey === '')
                    return '';
                var token = ''.concat(identifier, ':', sessionKey);
                return 'Basic ' + btoa(token);
            }
        }
    ]);